/**
 * We're keeping this around because we use USD in most cases for comparisons.
 * @type {string}
 */
export const CurrencyCodeUsd = 'USD';

/**
 * String Enum for Currency Codes that comply with the ISO-4217 standard
 * @enum {string}
 */
export const CurrencyCode = {
  AUD: 'AUD',
  CAD: 'CAD',
  CNY: 'CNY',
  EUR: 'EUR',
  GBP: 'GBP',
  PHP: 'PHP',
  SGD: 'SGD',
  USD: 'USD',
};
